export default __webpack_public_path__ + "poi-500-b74f0899ec48da8bc03eb9064ff23bfc.webp";